import type { RootState, AppDispatch } from "../redux/index";
import { useSelector, useDispatch, TypedUseSelectorHook } from "react-redux";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;
